import { useContext, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PropertyContext } from "../context/PropertyContext"
import { FaQuoteLeft } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaBed, FaBath, FaDollarSign, FaRulerCombined } from 'react-icons/fa';
import Logo from '../../public/assets/images/logo1.png';

// const properties = Array.from({ length: 9 }).map((_, i) => ({
//   id: i + 1,
//   title: `Beautiful Family House ${i + 1}`,
//   location: 'USA, NY',
//   price: (500000 + i * 10000).toLocaleString(),
//   image: `}`,
//   beds: 3,
//   baths: 2,
//   sqft: 2000 + i * 100,
//   type: i % 2 === 0 ? 'Single' : 'DUPLEX',
// }));


// export const properties = [
//   {
//   id: 1,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://img.freepik.com/premium-photo/stylized-blue-white-houses-arranged-row-blue-gradient-background_276930-6237.jpg?semt=ais_hybrid&w=740`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`, `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
//   },
// {
//   id: 2,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 3,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 4,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 5,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 6,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 7,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 8,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// },
// {
//   id: 9,
//   title: `Beautiful Family House`,
//   location: 'USA, NY',
//   price: 500000 .toLocaleString(),
//   image: `https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,
//   images:[`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,`https://inputs-outputs.org/wp-content/uploads/2020/11/shutterstock_306387839.jpg`,],
//   beds: 3,
//   baths: 2,
//   sqft: 2000,
//   type:  'DUPLEX',
// }
// ]








export default function RecentProperties() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDialog = () => {
    setIsOpen(!isOpen);
  };
  
   const { properties, loading } = useContext(PropertyContext);

  useEffect(() => {
    
    window.scrollTo(0, 0);
   
  }, []);
  
  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, []);


 
  return (
    <div className="bg-slate-900">
  {/* Hero Section */}
  <div className="relative md:h-[70vh] h-[40vh] overflow-hidden">
  {/* Background Video with Zoom Out */}
  <motion.div
    initial={{ scale: 1.2 }}
    animate={{ scale: 1 }}
    transition={{ duration: 3, ease: "easeOut" }}
    className="absolute inset-0"
  >
    <video
      className="w-full h-full object-cover"
      autoPlay
      loop
      muted
      playsInline
    >
      <source src="/assets/videos/investor-rise-bg-map.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </motion.div>

  {/* Overlay */}
  <div className="absolute inset-0 bg-black bg-opacity-30" />

  {/* Heading on the Left */}
  <div className="relative z-10 h-full flex-col items-end sm:items-center justify-start px-5 sm:px-10 pb-10 sm:pb-0 ml-4 md:ml-8 md:mt-48 mt-36">
  <div className="relative inline-block">
  <motion.div
    initial={{ opacity: 0, y: 80 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 2, ease: "easeOut" }}
    className="bg-black bg-opacity-40 rounded-xl shadow-xl px-6 py-4"
  >
    <h1 className="text-white text-5xl sm:text-4xl md:text-7xl font-semibold leading-tight">
      Recent Properties
    </h1>
  </motion.div>

  <motion.div
    animate={{ y: [0, -14, 3, 0] }}
    transition={{ repeat: Infinity, duration: 3 }}
    className="absolute top-[-20px] left-[-20px] w-[70px] h-[80px] border-t-[22px] border-l-[22px] border-teal-500 opacity-25 "
  />
</div>
<motion.p
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, delay: 0.3 }}
        className="text-base sm:text-2xl text-white py-3"
      >
      Browse through some of our recent, exclusive properties our investors have acquired.
      </motion.p>

<div className="px-5 sm:px-10 py-10 max-w-7xl mx-auto text-left">
     
    </div>
    
  </div>
  
</div>

<div className="pb-12 pt-12  px-4 md:px-20 bg-white">
       {properties.length==0?
(<p className="text-black text-center text-xl">No properties found.</p>):

( <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {properties.map((property,id) => (
            <Link to={`/recent-properties/detail/${property._id}`} key={property.id} className="bg-slate-200  overflow-hidden shadow-lg hover:shadow-2xl transition-all md:mb-32 mb-16">
              <div className="relative ">
                <img src={`https://investorrise-gxm0.onrender.com${property.mainImage}`} alt={property.title} className="w-full h-64 object-cover" />
                <div className="absolute top-4 right-3 flex flex-row gap-1">
                  <span className="bg-teal-500 text-white text-xs font-bold px-2 py-1 rounded">{property.status.toUpperCase()}!</span>
                  {/* <span className="bg-black text-white text-xs font-bold px-2 py-1 rounded">Duplix</span> */}
                </div>
              </div>
              <div className="p-4">
                <h2 className="text-lg font-bold mb-1 line-clamp-1 text-slate-800">{property.title}</h2>
                <div className="flex items-center text-gray-600 text-sm mb-2">
                  <FaMapMarkerAlt className="mr-1" /> United States
                </div>
                <div className="flex justify-evenly text-gray-700 text-base mb-1">
                  <span className="flex items-center"><FaBed className="mr-1 text-teal-500" /> {property.bedrooms} Beds</span>
                  <span className="flex items-center"><FaBath className="mr-1 text-teal-500 " /> {property.bathrooms} Baths</span>
                  <span className="flex items-center"><FaRulerCombined className="mr-1 text-teal-500" /> {property.area} sq ft</span>
                  
                </div>
                <hr className="my-2 border-black" />
                <div className="text-black font-bold flex items-center">
                  <FaDollarSign className="mr-1" />{property.price}
                </div>
              </div>
            </Link>
          ))}
        </div>)}
      </div>



 {/* <AnimatePresence>
        {isOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <motion.div
              initial={{ y: -100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: -100, opacity: 0 }}
              transition={{ duration: 0.4, ease: "easeOut" }}
              className="bg-slate-800 rounded-2xl shadow-xl w-[90%] max-w-md p-6 text-center relative"
            >
             
              <button
                onClick={toggleDialog}
                className="absolute top-3 right-3 text-white text-3xl hover:text-teal-500 transition duration-200"
              >
                &times;
              </button>

         
              <div className="flex justify-center mb-6">
                <img
                  src={Logo}
                  alt="Website Logo"
                  className="w-24 h-24 object-contain"
                />
              </div>

             
              <div className="flex flex-col gap-4">
                <Link to="/add-property">
               <button className="relative overflow-hidden py-3 px-8 mt-4 text-white font-semibold bg-slate-900 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-teal-500 to-teal-500 group-hover:from-teal-500 group-hover:to-teal-500 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Add Property</span>
        </button>
        </Link>
        <Link to="/delete-property">
                <button className="relative overflow-hidden py-3 px-8 mt-4 mb-2 text-white font-semibold bg-slate-900 shadow-xl text-lg group">
          <span className="absolute inset-0 bg-gradient-to-r from-red-600 to-red-600 group-hover:from-red-600 group-hover:to-red-600 animate-slide-bg transition-all duration-500 ease-in-out"></span>
          <span className="relative z-10">Delete Property</span>
        </button>
        </Link>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence> */}





</div>

  
  );
}
